/**
 * Kokochao V15 Alpha 2.3 product-only compatibility runtime.
 * Legacy PDP wishlist, share and delivery estimate controls.
 */
(() => {
  'use strict';

  const WISHLIST_KEY = 'kokochao_wishlist_handles';
  const boundWishlist = new WeakSet();
  const boundShare = new WeakSet();
  const boundDelivery = new WeakSet();

  const readWishlist = () => {
    try {
      const value = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (_) {}
    window.dispatchEvent(new CustomEvent('kc:wishlist-changed', { detail: { items } }));
  };

  function bindWishlist(root = document) {
    root.querySelectorAll?.('[data-kc-wishlist]:not([data-kc-v15-wishlist])').forEach((button) => {
      if (boundWishlist.has(button)) return;
      const handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      boundWishlist.add(button);

      const render = () => {
        const active = readWishlist().includes(handle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        const label = button.querySelector('[data-label]');
        if (label) label.textContent = active ? 'Ajouté aux favoris' : 'Ajouter aux favoris';
      };

      button.addEventListener('click', (event) => {
        event.preventDefault();
        const items = readWishlist();
        const index = items.indexOf(handle);
        if (index >= 0) items.splice(index, 1);
        else items.push(handle);
        writeWishlist(items);
        render();
      });
      window.addEventListener('kc:wishlist-changed', render);
      render();
    });
  }

  function bindShare(root = document) {
    root.querySelectorAll?.('[data-kc-share]').forEach((button) => {
      if (boundShare.has(button)) return;
      boundShare.add(button);
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        const title = button.getAttribute('data-title') || document.title;
        const url = button.getAttribute('data-url') || window.location.href;
        try {
          if (navigator.share) await navigator.share({ title, url });
          else if (navigator.clipboard) {
            await navigator.clipboard.writeText(url);
            const label = button.querySelector('[data-label]');
            if (label) {
              const previous = label.textContent;
              label.textContent = 'Lien copié';
              window.setTimeout(() => { label.textContent = previous; }, 1600);
            }
          }
        } catch (_) {}
      });
    });
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  }

  function addBusinessDays(start, days) {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
    }
    return date;
  }

  function bindDelivery(root = document) {
    root.querySelectorAll?.('[data-kc-delivery-estimate]').forEach((element) => {
      if (boundDelivery.has(element)) return;
      boundDelivery.add(element);
      const prepMin = Number.parseInt(element.getAttribute('data-prep-min-days') || '1', 10);
      const prepMax = Number.parseInt(element.getAttribute('data-prep-max-days') || '7', 10);
      const min = Number.parseInt(element.getAttribute('data-min-days') || '3', 10);
      const max = Number.parseInt(element.getAttribute('data-max-days') || '10', 10);
      const today = new Date();
      const shipFrom = addBusinessDays(today, prepMin);
      const shipTo = addBusinessDays(today, prepMax);
      const deliveryFrom = addBusinessDays(today, min);
      const deliveryTo = addBusinessDays(today, max);
      element.innerHTML = `<strong>Préparation estimée : entre le ${formatDate(shipFrom)} et le ${formatDate(shipTo)}</strong><small>Livraison suivie estimée entre le ${formatDate(deliveryFrom)} et le ${formatDate(deliveryTo)}, selon transporteur et disponibilité.</small>`;
    });
  }

  function hydrate(root = document) {
    bindWishlist(root);
    bindShare(root);
    bindDelivery(root);
  }

  function init() {
    hydrate(document);
    document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) hydrate(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
